import type { HelpTopicPair } from "../types";

const topic: HelpTopicPair = {
  th: {
    id: "groups",
    title: "กลุ่ม",
    summary:
      "กลุ่มคือทีมของผู้ใช้ เช่น ทีมซัพพอร์ต ทีมคลังสินค้า หรือบริษัทพาร์ทเนอร์ ใช้กำหนดว่าใครเข้าแอปไหนได้ (แอปเลือกอนุญาตเฉพาะสมาชิกของกลุ่มได้) และแอปยังใช้รายชื่อกลุ่มของผู้ใช้เพื่อกำหนดสิทธิ์ภายในแอปของตัวเองได้",
    access:
      'เปิดดูรายการกลุ่ม หน้ารายละเอียด และรายชื่อสมาชิกได้เมื่อมีสิทธิ์ groups:read (owner, admin, auditor) · สร้าง แก้ไข เพิ่ม/นำสมาชิกออก และลบกลุ่มได้เมื่อมีสิทธิ์ groups:write (owner, admin) · ส่วน "แอปที่ใช้กลุ่มนี้" แสดงเฉพาะผู้ที่มีสิทธิ์ clients:read',
    shot: { file: "groups-list.png", caption: "หน้ารายการกลุ่ม" },
    sections: [
      {
        id: "concept",
        heading: "กลุ่มต่างจากประเภทผู้ใช้และบทบาทอย่างไร",
        body: [
          "ประเภทผู้ใช้ บอกว่าบัญชีนี้เป็นใคร (employee, customer, partner) — หนึ่งบัญชีมีได้ประเภทเดียว",
          "กลุ่ม บอกว่าบัญชีนี้อยู่ทีมหรือบริษัทไหน — หนึ่งบัญชีอยู่ได้หลายกลุ่ม และกลุ่มหนึ่งมีสมาชิกได้ทุกประเภท",
          "บทบาท บอกว่าทำอะไรในคอนโซลผู้ดูแลนี้ได้บ้าง — ไม่เกี่ยวกับการเข้าแอปอื่น",
          'ตัวอย่าง: แอปหลังบ้านของแชทตั้งให้เข้าได้เฉพาะกลุ่ม support พนักงานที่อยู่ในกลุ่ม support จึงเข้าได้ ส่วนพนักงานคนอื่นจะเห็นหน้า "ไม่มีสิทธิ์เข้าถึง"',
          "บัญชีระบบ root ไม่สามารถเป็นสมาชิกของกลุ่มใดได้",
        ],
      },
      {
        id: "list",
        heading: "หน้ารายการกลุ่ม",
        body: [
          'เปิดจากเมนู การยืนยันตัวตน → กลุ่ม ด้านบนตารางมีคำอธิบายสั้น ๆ และแถบเครื่องมือของตาราง (ค้นหา กรอง เลือกคอลัมน์ ส่งออก) ปุ่ม "โหลดใหม่" และปุ่ม "สร้างกลุ่ม"',
          'คลิกที่แถวใดก็ได้เพื่อเปิดหน้ารายละเอียดของกลุ่มนั้น ถ้ายังไม่มีกลุ่มเลย จะเห็นข้อความ "ยังไม่มีกลุ่ม" พร้อมปุ่ม "สร้างกลุ่ม"',
        ],
        fieldsTitle: "คอลัมน์ในตาราง",
        fields: [
          { name: "ชื่อ", description: "ชื่อที่แสดงของกลุ่ม และใต้ชื่อเป็น ID ของกลุ่มตัวอักษรสีเทา" },
          {
            name: "ID",
            description: "รหัสถาวรของกลุ่ม (ซ่อนไว้โดยค่าเริ่มต้น เปิดได้จากเมนูเลือกคอลัมน์)",
          },
          { name: "คำอธิบาย", description: "คำอธิบายกลุ่ม (ถ้ามี)" },
          { name: "สมาชิก", description: "จำนวนสมาชิกในกลุ่ม" },
          { name: "สร้างเมื่อ", description: "วันที่สร้างกลุ่ม" },
        ],
      },
      {
        id: "create",
        heading: "สร้างกลุ่ม",
        shot: { file: "groups-create-dialog.png", caption: "หน้าต่างสร้างกลุ่ม" },
        fieldsTitle: "ช่องในหน้าต่าง",
        fields: [
          {
            name: "ID",
            required: true,
            description:
              "รหัสถาวรของกลุ่ม 2–41 ตัวอักษร ขึ้นต้นด้วยตัวพิมพ์เล็ก ตามด้วย a–z, 0–9, - หรือ _ เช่น chat-agents, partner-acme-logistics (ตัวพิมพ์ใหญ่จะถูกแปลงเป็นตัวพิมพ์เล็กให้) ID นี้ถูกส่งไปให้แอปใน token จึง เปลี่ยนภายหลังไม่ได้ และต้องไม่ซ้ำกับกลุ่มที่มีอยู่",
          },
          {
            name: "ชื่อ",
            description: 'ชื่อที่อ่านง่าย เช่น "ทีมแชทซัพพอร์ต" ถ้าเว้นว่าง ระบบใช้ ID เป็นชื่อ',
          },
          { name: "คำอธิบาย", description: "ไม่บังคับ ไม่เกิน 500 ตัวอักษร" },
        ],
        steps: [
          'กด "สร้างกลุ่ม" ที่มุมขวาบนของตาราง',
          'กรอก ID (ปุ่ม "สร้าง" จะกดได้เมื่อ ID ถูกรูปแบบ) และกรอกชื่อ/คำอธิบายถ้าต้องการ',
          'กด "สร้าง" — ระบบแสดง "สร้างกลุ่มแล้ว" และพาไปหน้ารายละเอียดของกลุ่มใหม่ทันที เพื่อเพิ่มสมาชิกต่อ',
        ],
        tips: [
          "ตั้ง ID ให้สื่อความหมายและคงที่ เพราะแอปต่าง ๆ อาจเขียนโค้ดตรวจ ID นี้ เช่น support-leads",
          "สำหรับพาร์ทเนอร์ แนะนำให้สร้างหนึ่งกลุ่มต่อหนึ่งบริษัท เช่น partner-acme-logistics",
        ],
      },
      {
        id: "detail",
        heading: "หน้ารายละเอียดกลุ่ม",
        shot: {
          file: "groups-detail.png",
          caption: "หน้ารายละเอียดกลุ่ม: ข้อมูลกลุ่ม สมาชิก แอปที่ใช้กลุ่มนี้ และโซนอันตราย",
        },
        body: [
          'ด้านบนมีลิงก์ "กลับไปหน้ากลุ่ม" ตามด้วยชื่อกลุ่ม ID (มีปุ่มคัดลอก) ป้ายจำนวน "สมาชิก N คน" และวันที่สร้าง',
          'ใต้หัวข้อมีฟอร์มแก้ไข "ชื่อ" (บังคับ ไม่เกิน 100 ตัวอักษร) และ "คำอธิบาย" (ไม่เกิน 500 ตัวอักษร) แก้แล้วกด "บันทึก" — ID แก้ไม่ได้',
          'หน้านี้มีส่วน "สมาชิก" ส่วน "แอปที่ใช้กลุ่มนี้" และโซนอันตรายสำหรับลบกลุ่ม (อธิบายด้านล่าง)',
        ],
      },
      {
        id: "members",
        heading: "สมาชิก",
        body: [
          "ตารางสมาชิกแสดงทุกคนในกลุ่ม คลิกแถวเพื่อไปหน้ารายละเอียดผู้ใช้คนนั้น",
          'ข้อความใต้หัวข้อ: "การนำสมาชิกออกจะเพิกถอน token ของแอปที่เขาไม่มีสิทธิ์ใช้แล้ว"',
        ],
        fieldsTitle: "คอลัมน์ในตาราง",
        fields: [
          { name: "ชื่อที่แสดง", description: "รูปและชื่อของผู้ใช้" },
          { name: "อีเมล", description: "อีเมลหลักของผู้ใช้" },
          { name: "ประเภทผู้ใช้", description: "ประเภทของบัญชี (employee, customer, partner ฯลฯ) กรองได้" },
          {
            name: 'ปุ่ม "นำออก"',
            description: "นำผู้ใช้ออกจากกลุ่ม (เห็นเฉพาะผู้มีสิทธิ์ groups:write) มีหน้าต่างยืนยันก่อน",
          },
        ],
      },
      {
        id: "add-members",
        heading: "เพิ่มสมาชิก",
        shot: {
          file: "groups-add-members-dialog.png",
          caption: "หน้าต่างเพิ่มสมาชิก พร้อมผู้ใช้ที่เลือกไว้",
        },
        steps: [
          'ในหน้ารายละเอียดกลุ่ม กด "เพิ่มสมาชิก" ที่แถบเครื่องมือของตารางสมาชิก',
          'หน้าต่าง "เพิ่มสมาชิกใน <ชื่อกลุ่ม>" แสดงผู้ใช้ 20 คนแรก พิมพ์ชื่อ อีเมล เบอร์โทร รหัสผู้ใช้งาน หรือชื่อผู้ใช้ในช่องค้นหาแล้วกด "ค้นหา" เพื่อหาคนที่ต้องการ',
          "ติ๊กช่องหน้าผู้ใช้ที่ต้องการเพิ่ม เลือกได้หลายคน และค้นหาใหม่ได้โดยรายการที่เลือกไว้ไม่หาย (อีเมลของคนที่เลือกแสดงเป็นป้ายสีฟ้าด้านบน)",
          'ผู้ที่เป็นสมาชิกอยู่แล้วจะมีป้าย "เป็นสมาชิกแล้ว" และติ๊กไม่ได้',
          'กด "เพิ่ม N คนที่เลือก" — ระบบแสดง "เพิ่มสมาชิก N คนแล้ว"',
        ],
        tips: [
          "สมาชิกใหม่จะเห็นกลุ่มนี้ในแอปหลังจากเข้าสู่ระบบใหม่หรือเมื่อ token ถูกต่ออายุ ไม่ใช่ทันที",
          "เพิ่มหรือแก้กลุ่มของผู้ใช้ทีละคนได้ด้วย ที่หน้ารายละเอียดผู้ใช้ → แท็บ สิทธิ์เข้าถึง",
          'ประเภทผู้ใช้กำหนด "กลุ่มเริ่มต้น" ได้ บัญชีใหม่ของประเภทนั้นจะถูกเพิ่มเข้ากลุ่มให้อัตโนมัติ',
        ],
      },
      {
        id: "remove-member",
        heading: "นำสมาชิกออก",
        steps: [
          'กด "นำออก" ในแถวของผู้ใช้',
          'หน้าต่าง "นำสมาชิกออก" ถามว่า "นำ <ชื่อ> ออกจาก <กลุ่ม>?"',
          'กด "นำออก" เพื่อยืนยัน — ระบบแสดง "นำสมาชิกออกแล้ว"',
        ],
        warnings: [
          "ถ้าผู้ใช้เข้าแอปใดได้เพราะอยู่ในกลุ่มนี้เท่านั้น การนำออกจะเพิกถอน token ของเขาที่แอปนั้นทันที เขาจะถูกออกจากระบบของแอปนั้นและเข้าใหม่ไม่ได้",
        ],
      },
      {
        id: "applications",
        heading: "แอปที่ใช้กลุ่มนี้",
        body: [
          'แสดงรายชื่อแอป (OAuth clients) ที่ตั้งสิทธิ์เข้าถึงแบบ "เฉพาะประเภทผู้ใช้และกลุ่มที่เลือก" และเลือกกลุ่มนี้ไว้ แต่ละแถวมีชื่อแอป (คลิกเพื่อเปิดหน้าแอป) client ID และสรุปว่าใครเข้าได้บ้าง',
          'ถ้ายังไม่มีแอปใดเลือกกลุ่มนี้ จะเห็น "ยังไม่มีแอปที่อนุญาตกลุ่มนี้" · การเพิ่มกลุ่มให้แอปทำที่หน้าแอป → แท็บ สิทธิ์เข้าถึง ไม่ใช่ที่หน้านี้',
        ],
      },
      {
        id: "delete",
        heading: "ลบกลุ่ม",
        shot: { file: "groups-delete-dialog.png", caption: "หน้าต่างยืนยันการลบกลุ่ม" },
        steps: [
          'เลื่อนลงไปที่ "โซนอันตราย" (หัวข้อสีแดง) ล่างสุดของหน้ารายละเอียดกลุ่ม',
          'กด "ลบกลุ่ม"',
          'อ่านข้อความในหน้าต่าง "ลบกลุ่ม <ชื่อ>" แล้วกด "ลบ" — ระบบแสดง "ลบกลุ่มแล้ว" และกลับไปหน้ารายการกลุ่ม',
        ],
        warnings: [
          "การลบกลุ่มย้อนกลับไม่ได้ สมาชิกทุกคนจะเสียสิทธิ์ที่ได้จากกลุ่มนี้ และ token ที่แอปซึ่งเขาไม่มีสิทธิ์แล้วจะถูกเพิกถอนทันที",
          "ลบไม่ได้ถ้ายังมีแอปใช้กลุ่มนี้ในสิทธิ์เข้าถึง หรือยังมีประเภทผู้ใช้ใช้กลุ่มนี้เป็นกลุ่มเริ่มต้น — ระบบจะแสดงข้อความผิดพลาดในหน้าต่าง ให้เอากลุ่มออกจากแอปและประเภทผู้ใช้เหล่านั้นก่อน",
        ],
      },
    ],
    related: ["users", "user-detail", "user-types", "client-detail", "roles"],
  },
  en: {
    id: "groups",
    title: "Groups",
    summary:
      "Groups are teams of users, such as the support team, the warehouse team or a partner company. They decide who can use which application (an application can admit only members of chosen groups), and applications can also use a user's groups for permissions inside the application.",
    access:
      'Viewing the list, a group\'s page and its members needs groups:read (owner, admin, auditor). Creating, editing, adding/removing members and deleting needs groups:write (owner, admin). The "Applications using this group" section is shown only to people with clients:read.',
    shot: { file: "groups-list.png", caption: "The groups list" },
    sections: [
      {
        id: "concept",
        heading: "Groups vs user types vs roles",
        body: [
          "A user type says who an account is (employee, customer, partner) — exactly one per account.",
          "A group says which team or company an account belongs to — an account can be in many groups, and a group can contain accounts of any type.",
          "A role says what someone may do in this admin console — it has nothing to do with signing in to other applications.",
          'Example: the chat back office admits only the support group. Employees in support can sign in; other employees see an "access denied" page.',
          "The root system account can never be a member of a group.",
        ],
      },
      {
        id: "list",
        heading: "The groups list",
        body: [
          'Open it from the menu Authentication → Groups. Above the table is a short explanation and the table toolbar (search, filter, columns, export), a "Reload" button and "Create group".',
          'Click any row to open that group\'s page. With no groups yet you see "No groups yet" and a "Create group" button.',
        ],
        fieldsTitle: "Columns in the table",
        fields: [
          { name: "Name", description: "The group's display name, with its ID in grey underneath." },
          {
            name: "ID",
            description: "The group's permanent ID (hidden by default; show it from the columns menu).",
          },
          { name: "Description", description: "The group's description, if any." },
          { name: "Members", description: "Number of members." },
          { name: "Created", description: "When the group was created." },
        ],
      },
      {
        id: "create",
        heading: "Create a group",
        shot: { file: "groups-create-dialog.png", caption: "The Create group window" },
        fieldsTitle: "Fields in the window",
        fields: [
          {
            name: "ID",
            required: true,
            description:
              "The permanent ID: 2–41 characters, a lowercase letter first, then a–z, 0–9, - or _, e.g. chat-agents or partner-acme-logistics (capitals are lower-cased automatically). It is sent to applications in tokens, so it cannot be changed later, and it must be unique.",
          },
          {
            name: "Name",
            description: 'A readable name such as "Chat support team". If left empty, the ID is used.',
          },
          { name: "Description", description: "Optional, up to 500 characters." },
        ],
        steps: [
          'Click "Create group" at the top right of the table.',
          'Enter the ID ("Create" becomes clickable once the ID is valid), and a name/description if you like.',
          'Click "Create" — "Group created" appears and you are taken to the new group\'s page to add members.',
        ],
        tips: [
          "Choose a meaningful, stable ID: applications may check it in their code, e.g. support-leads.",
          "For partners, create one group per partner company, e.g. partner-acme-logistics.",
        ],
      },
      {
        id: "detail",
        heading: "A group's page",
        shot: {
          file: "groups-detail.png",
          caption: "A group's page: details, members, applications using the group and the danger zone",
        },
        body: [
          'At the top: a "Back to groups" link, the group name, its ID (with a copy button), an "N members" badge and the creation date.',
          'Below is a form to edit "Name" (required, up to 100 characters) and "Description" (up to 500 characters); click "Save" after editing. The ID cannot be changed.',
          'The page then has the "Members" section, "Applications using this group" and a danger zone for deleting the group (see below).',
        ],
      },
      {
        id: "members",
        heading: "Members",
        body: [
          "The members table lists everyone in the group. Click a row to open that user's page.",
          'The note under the heading reads: "Removing a member revokes their tokens at applications they can no longer use."',
        ],
        fieldsTitle: "Columns in the table",
        fields: [
          { name: "Display name", description: "The user's picture and name." },
          { name: "Email", description: "The user's primary email." },
          {
            name: "User type",
            description: "The account's type (employee, customer, partner, …); filterable.",
          },
          {
            name: '"Remove" button',
            description: "Removes the user from the group (only with groups:write), after a confirmation.",
          },
        ],
      },
      {
        id: "add-members",
        heading: "Add members",
        shot: {
          file: "groups-add-members-dialog.png",
          caption: "The Add members window with users selected",
        },
        steps: [
          'On the group\'s page, click "Add members" in the members table toolbar.',
          'The "Add members to <group>" window shows the first 20 users. Type a name, email, phone number, user code or username in the search box and click "Search" to find people.',
          "Tick the users to add. You can pick several and search again without losing your picks (the picked emails show as blue badges at the top).",
          'People who are already members show a "Member" badge and cannot be ticked.',
          'Click "Add N selected" — "N members added" appears.',
        ],
        tips: [
          "New members see the group in applications after their next sign-in or token refresh, not instantly.",
          "You can also edit one user's groups on the user's page → Access tab.",
          'A user type can have "Default groups": new accounts of that type join them automatically.',
        ],
      },
      {
        id: "remove-member",
        heading: "Remove a member",
        steps: [
          'Click "Remove" in the user\'s row.',
          'The "Remove member" window asks "Remove <name> from <group>?".',
          'Click "Remove" to confirm — "Member removed" appears.',
        ],
        warnings: [
          "If the user could use an application only because of this group, their tokens at that application are revoked immediately: they are signed out of it and cannot sign in again.",
        ],
      },
      {
        id: "applications",
        heading: "Applications using this group",
        body: [
          'Lists the applications (OAuth clients) whose access is set to "Only selected user types and groups" and include this group. Each row shows the application name (click to open it), its client ID and a summary of who may sign in.',
          'If none uses the group you see "No application allows this group yet." Adding the group to an application is done on the application\'s page → Access tab, not here.',
        ],
      },
      {
        id: "delete",
        heading: "Delete a group",
        shot: { file: "groups-delete-dialog.png", caption: "The delete-group confirmation" },
        steps: [
          'Scroll to the "Danger zone" (red heading) at the bottom of the group\'s page.',
          'Click "Delete group".',
          'Read the "Delete group <name>" window and click "Delete" — "Group deleted" appears and you return to the list.',
        ],
        warnings: [
          "Deleting cannot be undone. All members lose the access the group gave them, and their tokens at applications they can no longer use are revoked immediately.",
          "A group that an application's access rule or a user type's default groups still uses cannot be deleted — an error appears in the window. Remove the group from those applications and user types first.",
        ],
      },
    ],
    related: ["users", "user-detail", "user-types", "client-detail", "roles"],
  },
};

export default topic;
